import { render, staticRenderFns } from "./conferenceBroadcast.vue?vue&type=template&id=263c1f75&scoped=true"
import script from "./conferenceBroadcast.vue?vue&type=script&lang=js"
export * from "./conferenceBroadcast.vue?vue&type=script&lang=js"
import style0 from "./conferenceBroadcast.vue?vue&type=style&index=0&id=263c1f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263c1f75",
  null
  
)

export default component.exports